import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

type ChartData = {
  date: string;
  accesses: number;
};

type AccessChartProps = {
  data: ChartData[];
};

export function AccessChart({ data }: AccessChartProps) {
  // Format data for the chart
  const chartData = data.map(item => ({
    ...item,
    // Format date to show day of week and day
    label: (() => {
      const date = new Date(item.date);
      const isToday = new Date().toDateString() === date.toDateString();
      if (isToday) return 'Hoje';
      return date.toLocaleDateString('pt-BR', {
        weekday: 'short',
        day: '2-digit'
      });
    })(),
  }));

  return (
    <div className="w-full h-48">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="label"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6b7280' }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6b7280' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              fontSize: '12px'
            }}
            labelStyle={{ color: '#374151', fontWeight: '500' }}
            formatter={(value: number) => [value, 'Acessos']}
          />
          <Bar
            dataKey="accesses"
            fill="#000000"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
